import BaseStyle from 'primevue/base/style';

var classes = {
  root: 'p-inputgroup-addon'
};
var InputGroupAddonStyle = BaseStyle.extend({
  name: 'inputgroupaddon',
  classes: classes
});

export { InputGroupAddonStyle as default };
